import { ChangeDetectionStrategy, Component } from '@angular/core'
import { SegmentTagV2 } from '../../shared/analytics/models/segment-tag.model'
import { AdConfig } from '../../shared/ads/advertising-service/ad-config'
import { AdComponentInputs } from '../../shared/ads/ad/ad-component.interface'
import { switchMap } from 'rxjs'
import { distinctUntilChanged, map } from 'rxjs/operators'
import {
  AD_ADHESION_SIZE,
  AD_LEADERBOARD_LARGE_FLEX_SIZE,
  AD_LEADERBOARD_SMALL_SIZE,
  AD_RECTANGLE_LARGE_SIZE,
  AD_SKIN_SIZE
} from '../../shared/ads/ads.utility'
import { environment } from '../../../environments/environment'
import { LeaguesDataService } from '../leagues-data.service'
import { ActivatedRoute } from '@angular/router'
import { trackById } from '../../shared/utility-functions/track-by-id.utility'

export const LEAGUES_LIST_TAG: SegmentTagV2 = {
  page_category: 'Leagues',
  subpage_category: 'Leagues List',
  category: 'Leagues',
  autoPageCall: false
}

@Component({
  templateUrl: './leagues-list.component.html',
  styleUrls: ['./leagues-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LeaguesListComponent {
  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly leaguesDataService: LeaguesDataService
  ) {}

  private navId$ = this.activatedRoute.queryParamMap.pipe(
    map(params => params.get('nav_id')),
    distinctUntilChanged()
  )

  public layout$ = this.navId$.pipe(
    switchMap(navId => {
      return this.leaguesDataService.getLeaguesByNavId(navId)
    })
  )

  /* Ads Stuff */
  public readonly AdComponent = import('../../shared/ads/ad/ad.component').then(m => m.AdComponent)

  // TODO: Replace all adDirectory/adSlotId with "leagues" instead of "rankings"
  public adSkin: AdComponentInputs = {
    config: {
      adConfig: AdConfig('rankings/list/atf', AD_SKIN_SIZE, 'ad-rankings-skin')
    }
  }
  public adLeaderboardLarge: AdComponentInputs = {
    config: {
      adConfig: AdConfig('rankings/list/728x90_flex', AD_LEADERBOARD_LARGE_FLEX_SIZE, 'ad-rankings-leaderboard'),
      additionalOpts: { deferClick: environment.advertising.preventClickTimeout, maxRefreshTime: 60000 }
    }
  }

  public adLeaderboardSmall: AdComponentInputs = {
    config: {
      adConfig: AdConfig('rankings/list/728x90_flex', AD_LEADERBOARD_SMALL_SIZE, 'ad-rankings-leaderboard-tablet'),
      additionalOpts: { maxRefreshTime: 60000 }
    }
  }

  public adSidebarRectangle: AdComponentInputs = {
    config: {
      adConfig: AdConfig('rankings/list/300x250_1', AD_RECTANGLE_LARGE_SIZE, 'ad-rankings-sidebar'),
      additionalOpts: { maxRefreshTime: 60000 }
    }
  }

  public adAdhesion: AdComponentInputs = {
    config: {
      adConfig: AdConfig('rankings/list/adhesion', AD_ADHESION_SIZE, 'ad-rankings-adhesion'),
      additionalOpts: { maxRefreshTime: 30000 }
    }
  }

  // TODO: Introduce adConfigMap and replace what's above ONLY IF we need ad targeting on this page

  protected readonly trackById = trackById
}
